
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3018_1806)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 16.5a8 8 0 100-16 8 8 0 000 16zm0-2.667c.74-2.863 2.47-4.593 5.333-5.333C10.47 7.76 8.74 6.03 8 3.167 7.26 6.03 5.53 7.76 2.667 8.5 5.529 9.24 7.26 10.97 8 13.833z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3018_1806"}},[_c('path',{attrs:{"transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    